<app-common-bulk-select-role-dialog
    #selectRoles
    [disabled]="roleBulkSelectDisabled"
></app-common-bulk-select-role-dialog>

<form class="role-modules-form" #form="ngForm">
    <mat-accordion multi>
        <mat-expansion-panel
            *ngFor="let module of moduleFeaturePermissions; let moduleIndex = index"
            [disabled]="!moduleDependencyMet(module) || !module.features?.length"
            [expanded]="module.warning && module.toggled"
        >
            <mat-expansion-panel-header [class.hide-toggle]="!module.features?.length">
                <mat-panel-title
                    ><label for="module-{{ moduleIndex }}">{{
                        module?.title ?? '' | translate
                    }}</label></mat-panel-title
                >
                <mat-panel-description
                    class="flex col"
                    matTooltip="{{
                        'settings.role-modules.dependencyMissingMessage'
                            | translate: { dependency: displayName(module.dependency) }
                    }}"
                    [matTooltipDisabled]="moduleDependencyMet(module)"
                    *ngIf="module.permissions"
                >
                    <mat-slide-toggle
                        color="primary"
                        class="padding-right-2 margin-left-auto"
                        id="module-{{ moduleIndex }}"
                        name="module-{{ moduleIndex }}"
                        [disabled]="role.isImmutable || !moduleDependencyMet(module)"
                        [(ngModel)]="module.toggled"
                        (ngModelChange)="onToggleModule(module)"
                        (click)="$event.stopPropagation()"
                    ></mat-slide-toggle>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="content">
                @if (module.warning) {
                    <ui-tip>
                        <span [innerHTML]="module.warning | translate"></span>
                    </ui-tip>
                }
                <ng-container *ngFor="let feature of module.features; let featureIndex = index">
                    <div class="padding-y-2">
                        <div class="flex space-between">
                            <label for="feature-{{ moduleIndex }}-{{ featureIndex }}">{{
                                feature.label | translate
                            }}</label>
                            <mat-slide-toggle
                                [matTooltip]="feature.tooltipDescription ?? '' | translate"
                                color="primary"
                                id="feature-{{ moduleIndex }}-{{ featureIndex }}"
                                name="feature-{{ moduleIndex }}-{{ featureIndex }}"
                                [disabled]="
                                    role.isImmutable ||
                                    (moduleIsToggleable(module) && !module.toggled) ||
                                    feature.isDisabled
                                "
                                [(ngModel)]="feature.toggled"
                                (ngModelChange)="disableDependentFeatureOnToggleOff(feature)"
                            ></mat-slide-toggle>
                        </div>

                        <div class="flex space-between padding-top-2" *ngIf="feature.showRoleModal && feature.toggled">
                            <mat-label>
                                {{
                                    'settings.role-modules.canAssignRolesMessage'
                                        | translate
                                            : {
                                                  assignableRoleCount: assignableRoles.length,
                                                  roleTotalCount: roleTotal,
                                              }
                                }}
                            </mat-label>
                            <ui-button type="link" (click)="openAssignableModal()">
                                <span *ngIf="!role.isImmutable">
                                    {{ 'settings.role-modules.editRoleButton' | translate }}
                                </span>
                                <span *ngIf="role.isImmutable">
                                    {{ 'settings.role-modules.viewRoleButton' | translate }}
                                </span>
                            </ui-button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <ui-card variant="outline">
        <app-segment-header
            title="{{ 'settings.role-modules.whatIsModuleAccessHeading' | translate }}"
        ></app-segment-header>
        <p>{{ 'settings.role-modules.whatIsModuleAccessMessage' | translate }}</p>
    </ui-card>
</form>
